module.exports = {
  productDetail: { // 详情页
    Product: 'Product Details',
    Included: 'Included Services',
    months: '12-months refurbisher warranty',
    returns: '30-day hassle-free returns',
    shipping: 'Free and express shipping',
    support: 'Customer care support',
    replace: 'In case of a defect, the item can be repaired free of charge. If it can not be repaired, we will replace it.',
    Simple: 'Once you receive your item, you have 30 days to give it a test run. If it doesn’t meet your expectations, return it. Simple as that.',
    Almost: 'Almost all products are free shipping. So you pay for what you want instead of shipping.',
    resolve: 'If you have any questions or problems, our business will reply you within 1 business day. If they don’t, we’ve got your back and we’ll help you resolve it.',
    Payments: 'Payments 100% secured',
    money: '30-day money back guarantee',
    minimum: '1-year minimum warranty',
    Free: 'Free Shipping',
    EMarket: 'Our partners are electronics experts who test and verify that each product is 100% functional before it leaves the factory. This is the reason you benefit from a minimum 1-Year warranty with the purchase of a refurbished device at YayTech.',
    Cart: 'Add to Cart',
    buy: 'Buy Now',
    Conditions: 'Conditions',
    Fair: 'Fair',
    Screen: 'Screen',
    Body: 'Body: A few visible scratches and some small dents that do not affect performance',
    Good: 'Good',
    ScreenNo: 'Screen:No scratches',
    odyLight: 'Body: Light micro scratches (invisible at arm’s length)',
    Excellent: 'Excellent',
    scratches: 'Screen: No scratches',
    invi_sible_from: 'Body: Like new, very light micro scratches (invisible from 8 inches away, a bit longer than a standard sized pencil).',
    Brand_New: 'Brand New',
    been_activated: 'Sealed in original box and device has never been activated or used. No scratches or marks anywhere on the screen or body.',
    All_conditions: 'All conditions are 100% fully functional. Condition refers only to cosmetic condition.',
    Sorry: 'Sorry, this device is no longer in stock, and we are working hard to restock it. In the meantime, check out our wide range of other devices.',
    Like: 'You May Also Like'
  },
  placeOrder: { // 立即购买页面
    address: 'Please select your delivery address',
    information: 'Please confirm the order information',
    Payment: 'Please select your payment method',
    Shop: 'Shop: ',
    Product: 'Product',
    Unit: 'Unit Price',
    Quantity: 'Quantity',
    Promo: 'Promo Info',
    Subtotal: 'Subtotal',
    Address: 'Add New Address',
    Subtotal_index: 'Subtotal',
    Shipping: 'Shipping',
    excluding: '4 business days(excluding handling time)',
    Promo_Info: 'Sales tax',
    Payout: 'Total Payout',
    included: 'Tax included',
    Confirm: 'Confirm and Pay',
    EMarket: 'YayTech is required by law to collect sales tax in most states. Taxes are calculated (estimated) on this page and then calculated at the time of payment.',
    requirements: 'If you have other requirements, please note',
    Default: 'Set as default',
    Default_address: 'Default address',
    Next: 'Next',
    Total: 'Total',
    YourOrder: 'Your order information',
    complete: 'You will be redirected to PayPal’s website to complete your payment.See you soon!',
    website: 'You will be redirected to Affirm’s website to complete your payment.See you soon!'
  },
  CheckoutSuccess: { // 下单成功页
    Placed: 'Order Placed Successfully!',
    products: 'Your product will be arriving soon! Please keep an eye out for notifications.',
    Shopping: 'Continue Shopping',
    Status: 'Track Order Status'
  },
  shoppingCart: {
    home: 'Home',
    myCart: 'My Cart',
    shoppingCart: 'Shopping Cart',
    selectAll: 'Select All',
    productsName: 'Products Name',
    price: 'Price',
    quantity: 'Quantity',
    subtotal: 'Subtotal',
    operating: 'Operating',
    checkout: 'Checkout',
    total: 'Total'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en-us/product.js